module.exports = __webpack_public_path__ + "static/media/allstate-big.9322b2a2.svg";